import pdfMake from "pdfmake/build/pdfmake";
import { pdfFontsVfs } from "./kanit-pdf-vfs";

pdfMake.addVirtualFileSystem(pdfFontsVfs);
pdfMake.addFonts({
  Kanit: {
    normal: "Kanit-Regular.ttf",
    bold: "Kanit-Bold.ttf",
    italics: "Kanit-Regular.ttf",
    bolditalics: "Kanit-Bold.ttf",
  },
});

export default pdfMake;
